import { render } from "./ExamType.vue?vue&type=template&id=3f3cbf9c&scoped=true"
import script from "./ExamType.vue?vue&type=script&lang=js"
export * from "./ExamType.vue?vue&type=script&lang=js"

import "./ExamType.vue?vue&type=style&index=0&id=3f3cbf9c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bmark-kid/bmark-kid-manage-html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f3cbf9c"]])

export default __exports__